import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=ede4d7a0"
import script from "./PlanItem.vue?vue&type=script&lang=js"
export * from "./PlanItem.vue?vue&type=script&lang=js"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=ede4d7a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports